module.exports = __webpack_public_path__ + "img/here-for-you.8c948615.svg";